import { ThisGorillaUtils } from "@thisgorilla/primate-ds";
import styled from "styled-components";
import { FlexRow } from "../../../../Common/Styles";
import { PreviewContent } from "../style";

export const PreviewContentSlider = styled(PreviewContent)`
  padding: ${({ theme }) => theme.spacing["spacing-6"].value}rem
    ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  min-width: ${ThisGorillaUtils.convertPxToRem("492")}rem;
`;

export const SliderOptionContainer = styled(FlexRow)`
  gap: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  padding-bottom: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;

export const CreateSlidetContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem
    ${({ theme }) => theme.spacing["spacing-2"].value}rem
    ${({ theme }) => theme.spacing["spacing-6"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  border: ${({ theme }) => theme.border_width["border-width-thin"].value}rem
    solid ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
  box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-s"]};
`;
